import { IconMessage16 } from '@cian/ui-kit';
import React, { forwardRef } from 'react';
import styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var SupportContactsWidgetOpenButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/_jsx("button", {
    ref: ref,
    type: "button",
    onClick: onClick,
    className: styles.container,
    "data-testid": "support-contacts-widget-open-button",
    children: /*#__PURE__*/_jsx(IconMessage16, {
      color: "white_100"
    })
  });
});
SupportContactsWidgetOpenButton.displayName = 'SupportContactsWidgetOpenButton';